import animate from "./animate";
import { easeInOutCubic } from "@shared/lib/animation/easing";
import { computed, ref } from "vue";
import useThreeElement from "./useThreeElement";

export default function useCamera () {
  const {
    camera,
    canvas,
  } = useThreeElement();

  const cameraFactor = ref(5 / 0.75);
  const tileWidth = computed(() => 612 / cameraFactor.value);

  function animateCameraZoom ({
    zoom,
    duration,
  }: {
    zoom: number,
    duration: number,
  }): Promise<void> {
    const startZoom = camera.zoom;

    return animate((t) => {
      camera.zoom = startZoom + (zoom - startZoom) * t;
      camera.updateProjectionMatrix();
      canvas.requestRender();
    }, {
      duration,
      easing: easeInOutCubic,
    });
  }

  return {
    cameraFactor,
    tileWidth,
    animateCameraZoom,
  };
}
